import React from 'react';

import PropTypes from 'prop-types';

import Drawer from '../Drawer/Drawer';

import HelpMeChooseTick from '../Common/Svg/HelpMeChooseTick';
import HelpMeChooseCross from '../Common/Svg/HelpMeChooseCross';

import './SpeedDrawer.css';

const speeds = [ '10 - 20 Mbps', '25 - 50 Mbps', '55 - 100 Mbps', '150 - 300 Mbps', '400 - 1000 Mbps' ];

const rows = [
  {
    label: 'Users & devices',
    values: [ '1 - 2', '3 - 6', '7 - 10', '11 - 15', '15+' ],
    sub: 'users / devices'
  },
  {
    label: 'HD streaming',
    values: [ '1 device', 'up to 4 devices', 'up to 6 devices', 'up to 10 devices', '10+ devices' ]
  },
  {
    label: '4K video streaming',
    values: [ '', 'up to 2 devices', 'up to 4 devices', 'up to 6 devices', '6+ devices' ]
  },
  {
    label: 'Seamless online gaming',
    values: [ ' ', 'multiple players', 'multiple players', 'multiple players', 'multiple players' ]
  }
];

const getIcon = (row, val) => {
  if (
    (row.label === '4K video streaming' ||
      row.label === 'Seamless online gaming') &&
    !val
  ) {
    return <HelpMeChooseCross />;
  }

  if (row.label !== 'Users & devices' && val) {
    return <HelpMeChooseTick />;
  }

  return null;
};

const SpeedDrawer = ({ isOpen, onClose }) => {

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}>

      <div className="speed-drawer">

        <div className="speed-drawer__header">

          <div className="speed-drawer__tag">SPEED GUIDE</div>
          <h2 className="speed-drawer__title">Find the right speed for you</h2>
          <p className="speed-drawer__subtitle">
            Use this guide to find the right speed for your household&apos;s online habits.
            All plans handle everyday tasks with ease.
          </p>
        </div>

        <div className="speed-drawer__table-wrapper">

          <table className="speed-drawer__table">

            <thead>
              <tr>
                <th className="speed-drawer__th speed-drawer__th--label"></th>
                {speeds.map((speed) => (
                  <th key={speed} className="speed-drawer__th">
                    {speed}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row) => (
                <tr key={row.label} className="speed-drawer__tr">
                  <td className="speed-drawer__td speed-drawer__td--label">{row.label}</td>
                  {row.values.map((val, i) => (
                    <td key={i} className="speed-drawer__td">
                      {getIcon(row, val)}
                      {val && <span className="speed-drawer__value">{val}</span>}
                      {row.sub && <span className="speed-drawer__sub">{row.sub}</span>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="speed-drawer__footer">
          <p className="speed-drawer__footer-text">
            Ready to choose a fibre plan?          </p>
          <button className='speed-drawer__button'
            onClick={onClose}>
            Choose now
          </button>
        </div>

      </div>
    </Drawer>
  );
};

SpeedDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default SpeedDrawer;